module.exports = __webpack_public_path__ + "media/images/eu100-298369278cfea88fe9f15e6ad0d1b7eb.svg";